// backend/src/lib/icons.js
import { createIcons, icons } from "lucide";

/**
 * Inicializa todos los <i data-lucide="..."></i>
 * Re-ejecutable para HTML inyectado (htmx, etc).
 */
export function initIcons(root = document) {
  createIcons({
    icons,
    attrs: {
      "stroke-width": "1.75",
      class: "lucide",
    },
    nameAttr: "data-lucide",
    root,
  });
}
